module.exports = "/_next/static/images/CollectDataDetails-e40e4467fb65fe5cf17b3e5e45f40f48.webp";